export default "__VITE_ASSET__B4AjIdj1__"